import * as React from 'react'
import { RouteComponentProps, withRouter } from 'react-router-dom'

import { Site } from '../../../../../common/constants/siteList'
import { ILocationParams } from '../../../../../common/reducers/reactRouterLocation'
import { getMinutesSecondsTime } from '../../../../../common/utils/time'

import ChevronRightIcon from '../../../../shared/components/icons/chevronRight'

import * as styles from './filterText.module.css'

interface IProps extends RouteComponentProps<any> {
  paramName: string
  name: string
  placeholder?: string
  locationParams: ILocationParams
  makeSearchLink: (params: ILocationParams, currentSite?: Site) => string
}

interface IState {
  value: string
}

class FilterText extends React.Component<IProps, IState> {
  private value: string

  constructor(props: IProps) {
    super(props)
    const { locationParams, paramName } = props

    const value = (locationParams && locationParams[paramName]) || ''

    this.state = {
      value
    }
  }

  public onChange(event: React.ChangeEvent<HTMLInputElement>) {
    this.setState({ value: event.target.value })
  }

  public onSubmit() {
    const { locationParams, history, makeSearchLink, paramName } = this.props

    const nextQuery = {
      ...locationParams,
      [paramName]: this.state.value
    }
    delete nextQuery.page

    if (!this.state.value) {
      delete nextQuery[paramName]
    }

    history.push(makeSearchLink(nextQuery) + '#content')
  }

  public onEnter(event: KeyboardEvent) {
    if (event.key === 'Enter') {
      event.preventDefault()
      this.onSubmit()
    }
  }

  public componentWillReceiveProps(nextProps: IProps) {
    const { locationParams, paramName } = nextProps

    if (locationParams[paramName] !== this.state.value) {
      this.setState({
        value: locationParams[this.value] || ''
      })
    }
  }

  public render() {
    const { placeholder } = this.props

    return (
      <div className={styles.inputsContainer}>
        <div className={styles.inputWrapper}>
          <input
            aria-label={this.props.name}
            type="text"
            name={this.props.name}
            className={styles.input}
            value={this.state.value}
            placeholder={placeholder}
            onChange={this.onChange.bind(this)}
            onKeyPress={this.onEnter.bind(this)}
          />
        </div>
        <button
          type="button"
          className={styles.buttonFilter}
          onClick={this.onSubmit.bind(this)}
        >
          <ChevronRightIcon width="8" height="12" />
        </button>
      </div>
    )
  }
}

export const FilterTextComponent = FilterText
export default withRouter(FilterText)
